<script setup lang="ts">
const { dynamicMetaConfig, defaultMetaConfig, baseMetaConfig, linkConfig } = useMeta()
// TODO: Indicator has bug if you navigate on the same route, but with params
const avoidIndicator = computed(() => useRoute().name === 'apotheke-finden')

useSeoMeta({
  ...defaultMetaConfig,
  ...dynamicMetaConfig,
})

useHead({
  meta: baseMetaConfig,
  link: linkConfig,
})
</script>

<template>
  <div font="sans">
    <NuxtLoadingIndicator
      v-if="!avoidIndicator"
      color="#312E2A"
      :height="3"
    />
    <NuxtLayout>
      <ModalModalsGlobal />
      <ModalChatModal />
      <NotificationGlobal />

      <template #alert>
        <AlertGlobal />
      </template>

      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<style lang="postcss">
html, body , #__nuxt{
  /* height: 100vh; */
  margin: 0;
  padding: 0;
  scroll-behavior: smooth;
}

.custom-scrollbar {
  overflow-y: overlay;

  &::-webkit-scrollbar {
    transform: translate(200px , 4px);
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 12px;
    width: 12px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 12px;
    background-color: rgba(221, 221, 221, 1);
  }
}

button {
  text-transform: initial !important;
}
</style>
